import type { NodeViewConstructor } from '@milkdown/kit/prose/view';
import { $view } from '@milkdown/kit/utils';
import '../../../../../styles/cards.css';
import { singleCardNode } from './singleCardNode';

/**
 * View plugin that renders single card nodes in the editor.
 *
 * Connects the ProseMirror node definition (singleCardNode) to a
 * lightweight DOM-backed node view for rendering.
 *
 * Uses the same structure as SlackishMarkdown CardBlockquote for
 * perfect visual parity between view and edit modes.
 */

export const singleCardView = $view(singleCardNode, () => {
  const view: NodeViewConstructor = (node, _view, _getPos, _decorations, _innerDecorations) => {
    const cardType = String(node.attrs.cardType || 'note');

    // Use the same structure as SlackishMarkdown for visual parity
    const dom = document.createElement('div');
    dom.className = `card-block card-${cardType}`;
    dom.dataset.cardType = cardType;

    const contentDOM = document.createElement('div');
    contentDOM.className = 'card-content';
    contentDOM.dataset.contentEditableIgnore = 'false';

    dom.appendChild(contentDOM);

    return {
      dom,
      contentDOM,
      update: (updatedNode) => {
        if (updatedNode.type !== node.type) return false;
        // Update card type if it changed
        const newCardType = String(updatedNode.attrs.cardType || 'note');
        if (newCardType !== cardType) {
          dom.className = `card-block card-${newCardType}`;
          dom.dataset.cardType = newCardType;
        }
        return true;
      },
    };
  };

  return view;
});
